const clearIndexedDb = async (): Promise<void> => {
  if (!("indexedDB" in window) || !indexedDB.databases) return;

  try {
    const databases = await indexedDB.databases();
    await Promise.all(
      databases.map(
        (db) =>
          new Promise<void>((resolve, reject) => {
            if (!db.name) {
              resolve();
              return;
            }

            const request = indexedDB.deleteDatabase(db.name);
            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
            request.onblocked = () => resolve();
          })
      )
    );
  } catch (error) {
    console.warn("Unable to clear IndexedDB", error);
  }
};

const clearCacheStorage = async (): Promise<void> => {
  if (!("caches" in window)) return;

  try {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  } catch (error) {
    console.warn("Unable to clear Cache Storage", error);
  }
};

export const clearBrowserStorage = async (): Promise<void> => {
  try {
    localStorage.clear();
  } catch (error) {
    console.warn("Unable to clear localStorage", error);
  }

  try {
    sessionStorage.clear();
  } catch (error) {
    console.warn("Unable to clear sessionStorage", error);
  }

  await Promise.all([clearIndexedDb(), clearCacheStorage()]);
};
